export default __webpack_public_path__ + "static/media/Home-icon.35247668.svg";